import React, { useState, useEffect, useRef } from 'react';
import { Box, Skeleton } from '@mui/material';

interface ChartContainerProps {
  children: React.ReactNode;
  height?: number;
}

const ChartContainer: React.FC<ChartContainerProps> = ({ children, height = 300 }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Pequeño retraso para asegurar que el DOM está listo
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: '100%',
        height,
        minWidth: 0,
        minHeight: height,
        position: 'relative'
      }}
    >
      {!isReady ? (
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height={height} 
          animation="wave"
          sx={{ borderRadius: 1 }}
        />
      ) : (
        children
      )}
    </Box>
  );
};

export default ChartContainer;